import * as jwt_decode from "jwt-decode";

class Auth {

    s(token) { // set the data
        let {
            exp,
            sub
        } = jwt_decode(token.token);
        exp = (exp + Date.now());
        const cred = [token.token, sub, token.email, token.first_name, token.last_name, token.role, JSON.stringify(exp.valueOf())]
        // console.log(cred);
        localStorage.setItem('data', this.e(cred));
        const lang = localStorage.getItem('lang');
        if (!lang) localStorage.setItem('lang', 'en');
        window.location.href = '/';
    }

    g() { // get the data
        const data = this.d();
        if (data.exp > Date.now()){
          return data;
        } else {
          localStorage.removeItem('mydata');
        }
        this.logout(); // Token has been expired
    }

    logged() { // check if the user is logged
        return this.g() ? true : false;
    }

    logout() { // logout
        localStorage.removeItem('data');
    }

    id() { // get the user id
        if (this.g()) return this.g().subject;
    }

    name() { // get the user name
        if (this.g()){
           return {
             first_name: this.g().fname,
             last_name: this.g().lname,
           }
        }
    }

    admin() { // check if the user is an admin
        if (this.g()) return this.g().role == 'admin' ? true : false;
    }

    user() { // check if the user is just a user
        if (this.g()) return this.g().role == 'user' ? true : false;
    }

    exp() { // check if expired
        return this.g() ? true : false;
    }

    e(cred) { // encode
      let baseData = btoa(unescape(encodeURIComponent(cred.toString())));
      // let baseData = btoa(cred.toString());
      return baseData.slice(0, 4) + 'E' + baseData.slice(4);
    }

    d() { //decode tok
        const cred = localStorage.getItem('data');
        let deco = [];

        if (cred) deco = decodeURIComponent(escape(atob(cred.slice(0, 4) + cred.slice(5)))).split(',');
        // if (cred) deco = atob(cred.slice(0, 4) + cred.slice(5)).split(',');
        return {
            token: deco[0] || null,
            subject: deco[1] || null,
            email: deco[2] || null,
            fname: deco[3] || null,
            lname: deco[4] || null,
            role: deco[5] || null,
            exp: deco[6] || null
        };
    };

}

export default Auth = new Auth()
